// extracted by mini-css-extract-plugin
export var border = "_j-7";
export var brand = "_j-s";
export var button = "_j-k";
export var center = "_j-9";
export var centered = "_j-5";
export var closeButton = "_j-b";
export var disabledWrapper = "_j-l";
export var error = "_j-o";
export var extraLarge = "_j-4";
export var extraSmall = "_j-1";
export var fill = "_j-h";
export var footer = "_j-g";
export var footerAction = "_j-i";
export var footerButtons = "_j-j";
export var header = "_j-6";
export var headerWithClose = "_j-c";
export var icon = "_j-n";
export var info = "_j-r";
export var inline = "_j-8";
export var large = "_j-3";
export var main = "_j-d";
export var modal = "_j-0";
export var neutral = "_j-t";
export var noPadding = "_j-f";
export var none = "_j-u";
export var scrollable = "_j-e";
export var small = "_j-2";
export var success = "_j-q";
export var tight = "_j-m";
export var titleIcon = "_j-a";
export var warn = "_j-p";